import vue from 'vue'
import axios from 'axios'

vue.prototype.$loading = false
vue.prototype.$axios = axios

// window.CONFIG = {};
// window.host = window.location.host.split(':')[1];

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/ems-web/' : '/ems-web/' 
// axios.defaults.baseURL = 'https://211.156.195.212/ems-web/'
//axios.defaults.baseURL = 'https://www.ems.com.cn/ems-web/' 		
// axios.defaults.baseURL = 'http://211.156.197.28/ems-web/'

axios.defaults.withCredentials = true
//请求拦截(请求发出前处理请求)
axios.interceptors.request.use(
	config => {
		vue.prototype.$loading = true
		return config;
	},
	error => {
		vue.prototype.$loading = false
		return Promise.error(error);
	}
)

//跨域解析
axios.jsonp = (url, data) => {
		if(!url)
			throw new Error('url is necessary')
		const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
		const JSONP = document.createElement('script')
		JSONP.setAttribute('type', 'text/javascript')
		const headEle = document.getElementsByTagName('head')[0]

		let ret = '';
		if(data) {
			if(typeof data === 'string')
				ret = '&' + data;
			else if(typeof data === 'object') {
				for(let key in data)
					ret += '&' + key + '=' + encodeURIComponent(data[key]);
			}
			ret += '&_time=' + Date.now();
		}
		JSONP.src = `${url}?callback=${callback}${ret}`;
		return new Promise((resolve, reject) => {
			window[callback] = r => {
				resolve(r)
				headEle.removeChild(JSONP)
				delete window[callback]
			}
			headEle.appendChild(JSONP)
		})
	},
	// 响应拦截器（处理响应数据）

	axios.interceptors.response.use(
		response => {
			vue.prototype.$loading = false
			if(response.status === 200) {
				switch(response.data.success) {
					case true:
						return Promise.resolve(response.data)

					case false:
					default:
						
						return Promise.reject(response)
				}

			} else {
				
				let errorMsg = "未知的错误请求";
				if(statusCode[response.status]) {
					errorMsg = statusCode[response.status]
				}

				return Promise.reject(response);
			}
		},
		error => {
			vue.prototype.$loading = false

			let errorMsg = "未知的错误请求";

			if(error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
				// errorMsg = "网络请求超时";
			} else if(error.message == 'Network Error') {
				//			errorMsg = 'Network Error'
			} else if(statusCode[error.response.status]) {
			} else {
			}
			

			return Promise.reject(error);

		}
	)

export default axios;